import { withChainedCapabilitiesBeforeNext } from './withChainedCapabilitiesBeforeNext';

/**
 * @param {Object} mapCapabilitiesToProps An object that contains a map of the capabilities to
 *  be called
 * @param {({payload, responses: [], props}) => any} callback Will be called after promise/promises
 *  is/are resolved.
 */
export const withCapabilityBeforeNext = (mapCapabilitiesToProps, callback = () => null) =>
  withChainedCapabilitiesBeforeNext(mapCapabilitiesToProps, {
    callback,
    forceCapabilitiesOrder: undefined,
  });
